"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[771],{

/***/ 91936:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SvgBtnGoogleLightNormalIos; }
/* harmony export */ });
/* harmony import */ var _dist_FancyIcon_68e31bdf_esm_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32735);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74512);





function SvgBtnGoogleLightNormalIos(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_dist_FancyIcon_68e31bdf_esm_js__WEBPACK_IMPORTED_MODULE_2__.F, (0,_dist_FancyIcon_68e31bdf_esm_js__WEBPACK_IMPORTED_MODULE_2__._)((0,_dist_FancyIcon_68e31bdf_esm_js__WEBPACK_IMPORTED_MODULE_2__._)({}, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
      viewBox: "0 0 46 46",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("defs", {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("rect", {
          id: "btn_google_light_normal_ios_svg__a",
          x: 0,
          y: 0,
          width: 40,
          height: 40,
          rx: 2
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("g", {
        fill: "none",
        fillRule: "evenodd",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("g", {
          transform: "translate(3 3)",
          filter: "url(#btn_google_light_normal_ios_svg__filter-1)",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("use", {
            fill: "#FFF",
            xlinkHref: "#btn_google_light_normal_ios_svg__a"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("use", {
            xlinkHref: "#btn_google_light_normal_ios_svg__a"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("use", {
            xlinkHref: "#btn_google_light_normal_ios_svg__a"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("use", {
            xlinkHref: "#btn_google_light_normal_ios_svg__a"
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
          d: "M31.64 23.205c0-.639-.057-1.252-.164-1.841H23v3.481h4.844a4.14 4.14 0 01-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615z",
          fill: "#4285F4"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
          d: "M23 32c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711h-3.007v2.332A8.997 8.997 0 0023 32z",
          fill: "#34A853"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
          d: "M17.964 24.71a5.41 5.41 0 01-.282-1.71c0-.593.102-1.17.282-1.71v-2.332h-3.007A8.996 8.996 0 0014 23c0 1.452.348 2.827.957 4.042l3.007-2.332z",
          fill: "#FBBC05"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
          d: "M23 17.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C27.463 14.891 25.426 14 23 14a8.997 8.997 0 00-8.043 4.958l3.007 2.332c.708-2.127 2.692-3.71 5.036-3.71z",
          fill: "#EA4335"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
          d: "M14 14h18v18H14V14z"
        })]
      })]
    })
  }));
}




/***/ }),

/***/ 34987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ FancyIconWrapper; },
/* harmony export */   "_": function() { return /* binding */ _objectSpread2; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96324);


function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var FancyIconWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "FancyIcon__FancyIconWrapper",
  componentId: "lui__sc-123trko-0"
})(["width:", ";height:", ";vertical-align:middle;& > svg{width:inherit;height:inherit;}"], _ref => {
  var {
    width
  } = _ref;
  return width !== null && width !== void 0 ? width : '1em';
}, _ref2 => {
  var {
    height
  } = _ref2;
  return height !== null && height !== void 0 ? height : '1em';
});




/***/ }),

/***/ 14258:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SvgLock; }
/* harmony export */ });
/* harmony import */ var _dist_Icon_3ba184f8_esm_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11418);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32735);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74512);
/* harmony import */ var _lendi_ui_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62792);






function SvgLock(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_dist_Icon_3ba184f8_esm_js__WEBPACK_IMPORTED_MODULE_3__.I, (0,_dist_Icon_3ba184f8_esm_js__WEBPACK_IMPORTED_MODULE_3__._)((0,_dist_Icon_3ba184f8_esm_js__WEBPACK_IMPORTED_MODULE_3__._)({}, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
        d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
      })]
    })
  }));
}




/***/ }),

/***/ 89915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(89799);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78645);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74512);
/* harmony import */ var _lendi_ui_typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56158);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32735);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96324);
/* harmony import */ var _lendi_ui_commons_colours__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56116);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76417);
/* harmony import */ var _helpers_tracking__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67458);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  white-space: nowrap;\n  color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var LinkWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_lendi_ui_typography__WEBPACK_IMPORTED_MODULE_2__/* .Link */ .rU).withConfig({
    componentId: "sc-e8c60e6f-0"
})(_templateObject(), function(_) {
    return (0,_lendi_ui_commons_colours__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)("interaction", "main");
});
var Disclaimer = function(param) {
    var _alignment = param.alignment, alignment = _alignment === void 0 ? "center" : _alignment, buttonText = param.buttonText;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_hooks__WEBPACK_IMPORTED_MODULE_5__/* .useTranslate */ .qM)([
        "PRIVACY_POLICY_LINK",
        "SITE_NAME"
    ]), 2), privacyPolicyLink = ref[0], siteName = ref[1];
    var handlePrivacyPolicyClick = function() {
        _helpers_tracking__WEBPACK_IMPORTED_MODULE_6__/* .eventTracking.trackAuthLinkClickEvent */ .fn.trackAuthLinkClickEvent("".concat(siteName, "'s Privacy Statement."));
    };
    var handleEndUserTermsClick = function() {
        _helpers_tracking__WEBPACK_IMPORTED_MODULE_6__/* .eventTracking.trackAuthLinkClickEvent */ .fn.trackAuthLinkClickEvent("".concat(siteName, "'s End User Terms."));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_lendi_ui_typography__WEBPACK_IMPORTED_MODULE_2__/* .Body */ .uT, {
        size: "sm",
        align: alignment,
        mt: "xxl",
        children: [
            "We are collecting your personal information in order to assist you with your home loan application or any other ancillary products. By clicking the '",
            buttonText,
            "' button you have read, consented and agreed to be bound by\xa0",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(LinkWrapper, {
                href: privacyPolicyLink === null || privacyPolicyLink === void 0 ? void 0 : privacyPolicyLink.toString(),
                onClick: handlePrivacyPolicyClick,
                children: "".concat(siteName, "’s Privacy Statement")
            }),
            siteName === "Aussie" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: [
                    "\xa0and the\xa0",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(LinkWrapper, {
                        href: "/about-us/property-end-terms/",
                        onClick: handleEndUserTermsClick,
                        children: "End User Terms"
                    })
                ]
            }),
            "."
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Disclaimer);


/***/ }),

/***/ 24940:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony exports DividerWrapper, HorizontalLine, ORText */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78645);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74512);
/* harmony import */ var _lendi_ui_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62792);
/* harmony import */ var _lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84209);
/* harmony import */ var _lendi_ui_typography__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56158);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32735);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96324);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 40%;\n  height: 0px;\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  font-weight: bold;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






var Divider = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(DividerWrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(HorizontalLine, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ORText, {
                children: "or"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(HorizontalLine, {})
        ]
    });
};
var DividerWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-60a6c4da-0"
})(_templateObject(), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_3__.my)("lg"));
var HorizontalLine = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].hr.withConfig */ .ZP.hr.withConfig({
    componentId: "sc-60a6c4da-1"
})(_templateObject1(), (0,_lendi_ui_color__WEBPACK_IMPORTED_MODULE_2__.fg)("shade.100"));
var ORText = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-60a6c4da-2"
})(_templateObject2(), (0,_lendi_ui_typography__WEBPACK_IMPORTED_MODULE_4__/* .body */ .d1)({
    size: "md",
    color: "shade.400"
}));
/* harmony default export */ __webpack_exports__["ZP"] = (Divider);


/***/ }),

/***/ 42496:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78645);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74512);
/* harmony import */ var _lendi_ui_icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14258);
/* harmony import */ var _lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84209);
/* harmony import */ var _lendi_ui_typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56158);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32735);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96324);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var EncriptionText = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(EncryptionTypeText, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_lendi_ui_icon__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                color: "shade.400"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_lendi_ui_typography__WEBPACK_IMPORTED_MODULE_3__/* .Body */ .uT, {
                ml: "xxxs",
                size: "xs",
                color: "shade.400",
                children: "256bit encryption"
            })
        ]
    });
};
var EncryptionTypeText = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-4b23e28-0"
})(_templateObject(), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_2__.my)("sm"));
/* harmony default export */ __webpack_exports__["Z"] = (EncriptionText);


/***/ }),

/***/ 51142:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "hr": function() { return /* binding */ AlertErrorSsi; },
/* harmony export */   "ne": function() { return /* binding */ AlertError; }
/* harmony export */ });
/* unused harmony export AlertWrapper */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78645);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74512);
/* harmony import */ var _lendi_ui_alert__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45402);
/* harmony import */ var _lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84209);
/* harmony import */ var _lendi_ui_typography__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56158);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32735);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96324);
/* harmony import */ var _state_state__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(79826);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var AlertError = function(param) {
    var error = param.error;
    return error && error.flow === _state_state__WEBPACK_IMPORTED_MODULE_6__/* .LALAAuthFlow.Passwordless */ .x1.Passwordless ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(AlertWrapper, {
        variant: "error",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
            children: [
                error.authError.description,
                error && error.authError.contactUs && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: [
                        " ",
                        "Please",
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_lendi_ui_typography__WEBPACK_IMPORTED_MODULE_4__/* .Link */ .rU, {
                            href: "/contactus",
                            color: "error.500",
                            children: "contact us"
                        }),
                        " ",
                        "to proceed."
                    ]
                })
            ]
        })
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {});
};
var AlertErrorSsi = function(param) {
    var error = param.error;
    return error && error.flow === _state_state__WEBPACK_IMPORTED_MODULE_6__/* .LALAAuthFlow.SSI */ .x1.SSI ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(AlertWrapper, {
        variant: "error",
        children: error.authError.description
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {});
};
var AlertWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_lendi_ui_alert__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-eaadf895-0"
})(_templateObject(), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_3__.mb)("sm"));


/***/ }),

/***/ 28270:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* binding */ GoogleSignInButton; }
});

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ../../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(44229);
// EXTERNAL MODULE: ../../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(97939);
// EXTERNAL MODULE: ../../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70111);
// EXTERNAL MODULE: ../../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(3541);
// EXTERNAL MODULE: ../../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 5 modules
var _sliced_to_array = __webpack_require__(89799);
// EXTERNAL MODULE: ../../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(78645);
// EXTERNAL MODULE: ../../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(92712);
// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/fancy-icon/BtnGoogleLightNormalIos/dist/fancy-icon.esm.js
var fancy_icon_esm = __webpack_require__(91936);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/modal/dist/modal.esm.js
var modal_esm = __webpack_require__(67429);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/spacing/dist/spacing.esm.js
var spacing_esm = __webpack_require__(84209);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/spinner/dist/spinner.esm.js + 1 modules
var spinner_esm = __webpack_require__(75910);
// EXTERNAL MODULE: ../../../packages/lala-react/dist/esm/index.js + 318 modules
var esm = __webpack_require__(25980);
// EXTERNAL MODULE: ../node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(67921);
// EXTERNAL MODULE: ../node_modules/launchdarkly-react-client-sdk/lib/esm/index.js + 1 modules
var lib_esm = __webpack_require__(91649);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(96324);
// EXTERNAL MODULE: ../../../node_modules/uuid/index.js
var uuid = __webpack_require__(24819);
// EXTERNAL MODULE: ./helpers/tracking/index.ts + 53 modules
var tracking = __webpack_require__(67458);
// EXTERNAL MODULE: ./state/actionProvider.tsx
var actionProvider = __webpack_require__(3842);
// EXTERNAL MODULE: ./state/state.ts
var state = __webpack_require__(79826);
// EXTERNAL MODULE: ./components/LightButton/index.tsx
var LightButton = __webpack_require__(4834);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/typography/dist/typography.esm.js
var typography_esm = __webpack_require__(56158);
;// CONCATENATED MODULE: ./components/SSIErrorModal/index.style.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 20rem;\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: bold;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: normal;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9b279a06-0"
})(_templateObject(), (0,spacing_esm.px)("xs"));
// @ts-ignore
var HeadingWrapper = (0,styled_components_browser_esm/* default */.ZP)(typography_esm/* Heading */.X6).withConfig({
    componentId: "sc-9b279a06-1"
})(_templateObject1());
var LinkWrapper = (0,styled_components_browser_esm/* default */.ZP)(typography_esm/* Link */.rU).withConfig({
    componentId: "sc-9b279a06-2"
})(_templateObject2());

// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/fancy-icon/dist/FancyIcon-68e31bdf.esm.js
var FancyIcon_68e31bdf_esm = __webpack_require__(34987);
;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/fancy-icon/PageNotFound/dist/fancy-icon.esm.js





function SvgPageNotFound(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FancyIcon_68e31bdf_esm.F, (0,FancyIcon_68e31bdf_esm._)((0,FancyIcon_68e31bdf_esm._)({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 100 100",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fill: "#00c0a5",
        fillRule: "evenodd",
        d: "M19.51 82.316l-2.008 1.212.532-2.284-1.774-1.537 2.337-.198.913-2.154.913 2.154 2.336.198-1.774 1.537.533 2.284-2.008-1.212z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M8.9 47.794a3.075 3.075 0 113.07-3.074 3.077 3.077 0 01-3.07 3.074zm0-5.249a2.175 2.175 0 102.17 2.175 2.178 2.178 0 00-2.17-2.175z",
        fill: "#00c0a5"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M20.743 60.545l1.222.738-.325-1.391 1.078-.935-1.418-.124-.552-1.309-.556 1.312-1.423.124 1.079.936-.325 1.39zm-3.249-2l2.336-.2.913-2.151.913 2.154 2.336.2-1.774 1.537.533 2.284-2.008-1.212-2.008 1.212.529-2.284zM81.027 15.228l2.008 1.211-.533-2.284 1.774-1.537-2.336-.198-.913-2.154-.913 2.154-2.336.198 1.774 1.537-.533 2.284 2.008-1.211z",
        fill: "#00c0a5",
        fillRule: "evenodd"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M94.842 62.228a2.419 2.419 0 112.418-2.419 2.421 2.421 0 01-2.418 2.419zm0-3.937a1.519 1.519 0 101.519 1.518 1.52 1.52 0 00-1.519-1.518zM50.591 10.381a3.194 3.194 0 011.036-3.493 3.127 3.127 0 013.839-.065c.315.31.245.155.1.55a3.96 3.96 0 01-.654.932 14.787 14.787 0 01-1.639 1.746 6.234 6.234 0 01-1.687 1.3c-.429.158-.3.187-.623-.194a2.757 2.757 0 01-.372-.776zm4.2.186a16.488 16.488 0 001.744-2.02 3.235 3.235 0 01-3.769 3.765 17.255 17.255 0 002.024-1.745zM46.635 85.622a14.651 14.651 0 004.923 4.58c.414.219 1.357.729 1.8.288.555-.558-.294-1.84-.587-2.306-.319.64.313 1.551-.938 1.06a4.5 4.5 0 01-.806-.46 12.416 12.416 0 01-2.081-1.8 13.6 13.6 0 01-1.446-1.749 5.23 5.23 0 01-.434-.731c-.1-.229-.336-.686-.1-.9.28-.252.769.081 1.119-.094-.479-.3-1.9-1.224-2.375-.47-.44.701.57 2.069.925 2.582zM17.349 18.706a.176.176 0 00-.053.158l.187 1.047-.985-.5a.174.174 0 00-.157 0l-.986.5.186-1.047a.173.173 0 00-.052-.158l-.784-.737 1.09-.153a.172.172 0 00.131-.093l.493-.962.493.962a.172.172 0 00.131.093l1.09.153zm1.194-1.032l-1.361-.191-.607-1.183a.183.183 0 00-.312 0l-.607 1.186-1.361.191a.175.175 0 00-.1.3l.98.921-.231 1.3a.176.176 0 00.252.187l1.218-.617 1.218.617a.176.176 0 00.252-.187l-.232-1.3.981-.921a.173.173 0 00.047-.18.175.175 0 00-.142-.121zM22.671 14.1a.174.174 0 00.17-.048L23.891 13a.175.175 0 00-.248-.248L22.594 13.8a.174.174 0 00-.048.17.176.176 0 00.125.13zM22.316 14.576a.175.175 0 00-.247-.247l-2.45 2.449a.175.175 0 10.248.248zM21.894 12.579l-1.05 1.05a.175.175 0 10.248.247l1.049-1.049a.175.175 0 00-.247-.248zM20.565 14.156a.175.175 0 00-.246 0L17.87 16.6a.174.174 0 00-.048.17.175.175 0 00.3.078l2.45-2.45a.175.175 0 00-.007-.242zM24.588 13.806a.175.175 0 00-.245 0l-.525.525-1.049 1.049-.525.525-2.45 2.45a.175.175 0 00.078.295.174.174 0 00.17-.048l2.449-2.449.525-.525 1.05-1.05.525-.525a.174.174 0 00-.003-.247zM22.316 10.655a.173.173 0 00-.247 0L17.52 15.2a.175.175 0 10.247.247l4.549-4.547a.175.175 0 000-.245zM79.345 84.088a.2.2 0 00-.191.054l-1.181 1.181a.2.2 0 00.278.278l1.181-1.181a.194.194 0 00.054-.191.2.2 0 00-.141-.141zM79.744 83.552a.2.2 0 00.279.278l2.755-2.756a.2.2 0 10-.278-.274zM81.122 84.339l-1.181 1.181a.2.2 0 00.279.278l1.18-1.181a.2.2 0 00-.087-.332.2.2 0 00-.191.054zM81.715 84.024a.2.2 0 00.276 0l2.756-2.756a.2.2 0 00-.087-.332.2.2 0 00-.192.054l-2.755 2.755a.2.2 0 00.002.279zM79.236 82.649l.59-.591 2.756-2.758a.2.2 0 10-.279-.278l-2.755 2.758-.591.591-1.181 1.181-.59.59a.2.2 0 00.278.278l.591-.59zM85.053 82.514a.2.2 0 00-.191.053l-5.118 5.118a.2.2 0 00.279.278l5.117-5.117a.2.2 0 00-.087-.332zM85 34.96a2.992 2.992 0 005.039 2.182 3.3 3.3 0 01-2.177-5.171A2.992 2.992 0 0085 34.96z",
        fill: "#00c0a5"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
        cx: 25.954,
        cy: 31.598,
        r: 1.312,
        fill: "#00c0a5"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
        cx: 78.44,
        cy: 49.968,
        r: 1.312,
        fill: "#00c0a5"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
        cx: 94.186,
        cy: 26.349,
        r: 1.312,
        fill: "#00c0a5"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
        cx: 57.446,
        cy: 25.037,
        r: 1.312,
        fill: "#00c0a5"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
        cx: 37.763,
        cy: 70.963,
        r: 1.312,
        fill: "#00c0a5"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
        cx: 69.255,
        cy: 73.587,
        r: 1.312,
        fill: "#00c0a5"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M58.269 47.319a.954.954 0 01-.47-.124l-5.393-3.054a.953.953 0 00-.942 0L46.1 47.194a.959.959 0 01-.471.125h-6.165v10.844a.954.954 0 00.954.953h22.858a.954.954 0 00.954-.953V47.319z",
        fill: "#edf7f5"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M63.276 59.355H40.418a1.193 1.193 0 01-1.192-1.192V47.08h6.406a.71.71 0 00.354-.094l5.36-3.051a1.2 1.2 0 011.177 0l5.393 3.053a.713.713 0 00.353.093h6.2v11.082a1.194 1.194 0 01-1.193 1.192zM39.7 47.557v10.606a.716.716 0 00.716.715h22.86a.716.716 0 00.715-.715V47.557h-5.722a1.2 1.2 0 01-.588-.155l-5.393-3.053a.719.719 0 00-.706 0L46.221 47.4a1.193 1.193 0 01-.589.156z",
        fill: "#00c0a5"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M63.379 47.319v10.1a.954.954 0 01-.954.954H39.488a.954.954 0 00.93.742h22.858a.954.954 0 00.954-.953V47.319z",
        fill: "#00c0a5",
        opacity: 0.2
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M65.241 47.557h-6.972a1.2 1.2 0 01-.588-.155l-5.393-3.053a.719.719 0 00-.706 0L46.221 47.4l-.118-.207.118.207a1.193 1.193 0 01-.589.156h-7.153a.716.716 0 01-.667-.976l2.737-7a1.186 1.186 0 011.11-.758h20.57a1.2 1.2 0 011.119.782l2.564 6.996a.716.716 0 01-.671.962zm-13.3-3.777a1.186 1.186 0 01.587.154l5.393 3.053a.713.713 0 00.353.093h6.972a.239.239 0 00.224-.32l-2.57-6.99a.718.718 0 00-.671-.469h-20.57a.712.712 0 00-.666.455l-2.736 7a.233.233 0 00.025.221.235.235 0 00.2.1h7.153a.71.71 0 00.354-.094l5.36-3.051a1.2 1.2 0 01.587-.152z",
        fill: "#00c0a5"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M47.091 39.3h-3.339a.238.238 0 01-.238-.238v-2.053a1.194 1.194 0 011.192-1.192h1.432a1.194 1.194 0 011.192 1.192v2.054a.238.238 0 01-.239.237zm-3.1-.477h2.862v-1.814a.716.716 0 00-.715-.715h-1.432a.715.715 0 00-.715.715zM55.128 59.355h-6.537a.239.239 0 01-.238-.239v-8.051a1.194 1.194 0 011.192-1.192h4.629a1.193 1.193 0 011.192 1.192v8.051a.238.238 0 01-.238.239zm-6.3-.477h6.06v-7.813a.716.716 0 00-.716-.715h-4.627a.715.715 0 00-.715.715zM83.99 80.067l1.53.214.684 1.334a.2.2 0 00.35 0l.683-1.334 1.531-.214a.2.2 0 00.108-.339l-1.1-1.037.26-1.461a.2.2 0 00-.282-.21l-1.371.7-1.371-.7a.2.2 0 00-.282.21l.26 1.461-1.1 1.037a.2.2 0 00.108.338zM56.447 8.205a14.651 14.651 0 01-4.923 4.58c-.414.218-1.357.729-1.8.288-.555-.559.294-1.84.588-2.306.318.639-.314 1.551.937 1.059a4.458 4.458 0 00.806-.459 12.422 12.422 0 002.081-1.8 13.533 13.533 0 001.444-1.753 5.22 5.22 0 00.434-.73c.1-.229.337-.686.1-.9-.28-.251-.769.081-1.118-.094.478-.3 1.9-1.223 2.375-.469.441.703-.571 2.071-.924 2.584zM52.491 87.8a3.194 3.194 0 00-1.036-3.493 3.125 3.125 0 00-3.839-.066c-.315.311-.245.155-.1.551a3.963 3.963 0 00.654.931 14.714 14.714 0 001.639 1.746 6.273 6.273 0 001.687 1.3c.43.157.3.186.623-.2a2.764 2.764 0 00.372-.769zM48.292 87.984a16.5 16.5 0 01-1.744-2.02 3.236 3.236 0 003.77 3.766 17.1 17.1 0 01-2.026-1.746z",
        fill: "#00c0a5"
      })]
    })
  }));
}



// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/button/dist/button.esm.js
var button_esm = __webpack_require__(22294);
;// CONCATENATED MODULE: ./components/SSIErrorModal/index.tsx







var SSIErrorModal = function(param) {
    var error = param.error, onCloseModal = param.onCloseModal;
    var ref = (0,actionProvider/* useActions */.ol)(), authorisePopup = ref.authorisePopup, resetError = ref.resetError;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgPageNotFound, {
                height: "7.5em",
                width: "7.5em"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadingWrapper, {
                color: "shade.700",
                size: "md",
                mt: "md",
                mb: "xs",
                children: "Something went wrong"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(typography_esm/* Body */.uT, {
                color: "shade.600",
                align: "center",
                mb: "md",
                children: [
                    "Sign in with Google did not work, please try again or let us know",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper, {
                        href: "/contactus",
                        children: "[here]"
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(button_esm/* Button */.zx, {
                variant: "primary",
                onClick: function() {
                    if (error) resetError();
                    onCloseModal();
                    authorisePopup("google-oauth2");
                },
                isFullWidth: true,
                children: "TRY AGAIN"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/GoogleSignInComponent/index.tsx







function GoogleSignInComponent_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: 6;\n  ",
        "\n  ",
        "\n"
    ]);
    GoogleSignInComponent_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
















var ModalWrapper = (0,styled_components_browser_esm/* default */.ZP)(modal_esm/* default */.ZP).withConfig({
    componentId: "sc-fef742ba-0"
})(GoogleSignInComponent_templateObject(), (0,spacing_esm.px)("lg"), (0,spacing_esm.pb)("sm"));
var GoogleSignInButton = function(props) {
    var ref = (0,actionProvider/* useActions */.ol)(), authorisePopup = ref.authorisePopup, resetError = ref.resetError;
    var brand = (0,esm/* useSession */.kP)().brand;
    var ldClient = (0,lib_esm/* useLDClient */.mC)();
    var targetId = js_cookie.get("targetId") || (0,uuid.v4)();
    js_cookie.set("hasSSOAccessed", "true");
    var handleClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        tracking/* eventTracking.trackAuthButtonClickEvent */.fn.trackAuthButtonClickEvent("SSO", "Sign in with Google", "secondary");
                        return [
                            4,
                            ldClient === null || ldClient === void 0 ? void 0 : ldClient.identify({
                                kind: "multi",
                                unauthUser: {
                                    key: targetId,
                                    isTeamView: false,
                                    hasSSOAccessed: true,
                                    brand: brand
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        if (props.error) resetError();
                        authorisePopup("google-oauth2");
                        return [
                            2
                        ];
                }
            });
        });
        return function handleClick() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleButton, (0,_object_spread/* default */.Z)({
        onClick: handleClick
    }, props));
};
var GoogleButton = function(_param) {
    var error = _param.error, onClick = _param.onClick, verifying = _param.verifying, _children = _param.children, margin = (0,_object_without_properties/* default */.Z)(_param, [
        "error",
        "onClick",
        "verifying",
        "children"
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), openModal = ref[0], setOpenModal = ref[1];
    react.useEffect(function() {
        if (error && error.flow === state/* LALAAuthFlow.SSI */.x1.SSI) {
            setOpenModal(true);
        } else {
            setOpenModal(false);
        }
    }, [
        error
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LightButton/* LightButton */.a, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                variant: "secondary",
                isFullWidth: true,
                isDisabled: verifying,
                onClick: onClick
            }, margin), {
                before: /*#__PURE__*/ (0,jsx_runtime.jsx)(fancy_icon_esm/* default */.Z, {
                    width: "3.5em",
                    height: "3.5em"
                }),
                children: verifying ? /*#__PURE__*/ (0,jsx_runtime.jsx)(spinner_esm/* default */.Z, {
                    variant: "dark"
                }) : "Sign in with Google"
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalWrapper, {
                isVisible: openModal,
                size: "md",
                onHide: function() {
                    return setOpenModal(!openModal);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_esm/* default.Content */.ZP.Content, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SSIErrorModal, {
                        error: error,
                        onCloseModal: function() {
                            return setOpenModal(false);
                        }
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var GoogleSignInComponent = ((/* unused pure expression or super */ null && (GoogleButton)));


/***/ }),

/***/ 4834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ LightButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78645);
/* harmony import */ var _lendi_ui_button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22294);
/* harmony import */ var _lendi_ui_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62792);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96324);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  && {\n    border-color: ",
        ";\n    ",
        "\n    ",
        "\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



// @ts-ignore
var LightButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_lendi_ui_button__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx).withConfig({
    componentId: "sc-87bc0380-0"
})(_templateObject(), (0,_lendi_ui_color__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$)("shade.200"), (0,_lendi_ui_color__WEBPACK_IMPORTED_MODULE_2__.bg)("shade.0"), (0,_lendi_ui_color__WEBPACK_IMPORTED_MODULE_2__.fg)("shade.700"));


/***/ }),

/***/ 44556:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ BoldHeading; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78645);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96324);
/* harmony import */ var _lendi_ui_typography__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56158);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: bold;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


// @ts-ignore
var BoldHeading = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_lendi_ui_typography__WEBPACK_IMPORTED_MODULE_1__/* .Heading */ .X6).withConfig({
    componentId: "sc-6e4e75cf-0"
})(_templateObject());


/***/ }),

/***/ 18457:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "t": function() { return /* binding */ setPrlAndReferralParamsToStorage; }
});

// EXTERNAL MODULE: ../../../packages/lala-utils/dist/esm/index.js + 23 modules
var esm = __webpack_require__(82839);
;// CONCATENATED MODULE: ./helpers/getParamFromReturnUrl.ts
var ParamName;
(function(ParamName) {
    ParamName["StoreId"] = "storeid";
    ParamName["BrokerId"] = "brokerid";
})(ParamName || (ParamName = {}));
var getParamFromReturnUrl = function(params, paramName) {
    var returnUrlParam = params.get("returnurl");
    if (!returnUrlParam) return null;
    var index = returnUrlParam.indexOf("?");
    if (index === -1) return null;
    var returnUrlParams = new URLSearchParams(returnUrlParam.substring(index + 1));
    var brokerIdFromReturnUrl = returnUrlParams.get(paramName);
    return brokerIdFromReturnUrl;
};

;// CONCATENATED MODULE: ./helpers/setPrlAndReferralParamsToStorage.ts


function setPrlAndReferralParamsToStorage() {
    var ref;
    var params = new URLSearchParams((ref = window.location.search) === null || ref === void 0 ? void 0 : ref.toLowerCase());
    var storeIdFromLocalStorage = localStorage.getItem(esm/* PRL_STORE_ID */.Rj);
    var brokerIdFromLocalStorage = localStorage.getItem(esm/* PRL_BROKER_ID */.Gz);
    var refCodeFromLocalStorage = localStorage.getItem(esm/* CUSTOMER_REFERRAL_CODE */.TX);
    var companyGenFromLocalStorage = localStorage.getItem(esm/* PRL_COMPANY_GEN */.$I);
    var campaignNameFromLocalStorage = localStorage.getItem(esm/* PRL_CAMPAIGN_NAME */.E4);
    var isParamSet = storeIdFromLocalStorage || brokerIdFromLocalStorage || refCodeFromLocalStorage || companyGenFromLocalStorage || campaignNameFromLocalStorage;
    if (!isParamSet) {
        var storeId = params.get("storeid") || getParamFromReturnUrl(params, ParamName.StoreId);
        if (storeId) {
            localStorage.setItem(esm/* PRL_STORE_ID */.Rj, storeId);
        }
        var brokerId = params.get("brokerid") || getParamFromReturnUrl(params, ParamName.BrokerId);
        if (brokerId) {
            localStorage.setItem(esm/* PRL_BROKER_ID */.Gz, brokerId);
        }
        var refCode = params.get("refcode");
        if (refCode) {
            localStorage.setItem(esm/* CUSTOMER_REFERRAL_CODE */.TX, refCode);
        }
        var companyGen = params.get("cgen");
        if (companyGen) {
            localStorage.setItem(esm/* PRL_COMPANY_GEN */.$I, companyGen);
        }
        var campaignName = params.get("cname");
        if (campaignName) {
            localStorage.setItem(esm/* PRL_CAMPAIGN_NAME */.E4, campaignName);
        }
    }
}


/***/ }),

/***/ 29580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bt": function() { return /* binding */ AuthForm; },
/* harmony export */   "En": function() { return /* binding */ BenefitsUnit; },
/* harmony export */   "GL": function() { return /* binding */ BeforeWrapper; },
/* harmony export */   "NL": function() { return /* binding */ Prompt; },
/* harmony export */   "Om": function() { return /* binding */ NoBr; },
/* harmony export */   "WR": function() { return /* binding */ DivMBSM; },
/* harmony export */   "Z0": function() { return /* binding */ Separator; },
/* harmony export */   "_U": function() { return /* binding */ MainContentWrapper; },
/* harmony export */   "dx": function() { return /* binding */ PromptHeader; },
/* harmony export */   "eX": function() { return /* binding */ Actions; },
/* harmony export */   "im": function() { return /* binding */ Wrapper; },
/* harmony export */   "jn": function() { return /* binding */ RFFFieldWrapper; },
/* harmony export */   "wC": function() { return /* binding */ PromptMessage; },
/* harmony export */   "zL": function() { return /* binding */ YesNoButton; }
/* harmony export */ });
/* unused harmony exports ContentUnit, ExpiredUnit, CardWrapper, DefaultLoginWrapper, LoginVariantWrapper, LoginVariantContainer, ExtraContainer, StyledRequestCode, Content, Heading, SubHeading, Mainpage, ContentWrapper, AlertWrapper, WordWrapper */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78645);
/* harmony import */ var _lendi_ui_alert__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45402);
/* harmony import */ var _lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23783);
/* harmony import */ var _lendi_ui_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62792);
/* harmony import */ var _lendi_ui_container__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58905);
/* harmony import */ var _lendi_ui_depth__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(12987);
/* harmony import */ var _lendi_ui_grid__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63518);
/* harmony import */ var _lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84209);
/* harmony import */ var _lendi_ui_typography__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(56158);
/* harmony import */ var _lendi_ui_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(27233);
/* harmony import */ var _lendi_ui__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(67151);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(96324);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    display: block;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: none;\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  height: 100%;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  position: absolute;\n  width: 250px;\n  right: 0;\n  top: calc(2.5 * var(--lendi-ui-size));\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: 978px;\n  margin: 0 auto;\n  display: flex;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    ",
        "\n    justify-content: space-evenly;\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  display: flex;\n  justify-content: space-around;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n  font-weight: bold;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.14;\n  letter-spacing: normal;\n  text-align: center;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  line-height: 1.38;\n  text-align: center;\n  ",
        "\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    margin-top: calc(-4 * var(--lendi-ui-size));\n  "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  position: relative;\n  margin-top: calc(-2 * var(--lendi-ui-size));\n  ",
        "\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    ",
        "\n  "
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  white-space: nowrap;\n  ",
        "\n  ",
        "\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  white-space: nowrap;\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  white-space: nowrap;\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 320px;\n  "
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  margin: auto;\n\n  ",
        "\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  border: none;\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-top: 64px;\n  background: var(--background-page, #f8f8f8);\n  color: var(--text-main, #474747);\n  font-style: normal;\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 553px;\n  "
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  width: 90%;\n  ",
        "\n  padding: 20px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 20px;\n  border-radius: 6px;\n  background: var(--background-container, #fff);\n  ",
        ";\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-self: stretch;\n  font-weight: 400;\n  font-size: 24.5px;\n  line-height: 28.17px;\n  text-align: center;\n"
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-self: stretch;\n"
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: auto;\n    flex-direction: row;\n  "
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: flex-start;\n  gap: 20px;\n  width: 100%;\n  flex-direction: column;\n  ",
        "\n"
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 212px;\n  "
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  display: flex;\n  width: 100%;\n  height: 48px;\n  padding: 0px 16px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  > span {\n    font-size: 14px;\n    line-height: 14px;\n    letter-spacing: 1px;\n    text-transform: uppercase;\n  }\n"
    ]);
    _templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}











// @ts-ignore
var ContentUnit = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-29f87150-0"
})(_templateObject(), (0,_lendi_ui_grid__WEBPACK_IMPORTED_MODULE_5__/* .unit */ .bf)({
    size: {
        mobile: 1,
        tablet: 1 / 2
    }
}), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_6__.px)({
    mobile: "sm",
    tablet: "md"
}));
var ExpiredUnit = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-29f87150-1"
})(_templateObject1(), (0,_lendi_ui_grid__WEBPACK_IMPORTED_MODULE_5__/* .unit */ .bf)({
    size: {
        mobile: 1,
        tablet: 1 / 2
    }
}), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_6__.px)({
    mobile: "sm",
    tablet: "md"
}));
var BenefitsUnit = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_lendi_ui_grid__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Unit */ .ZP.Unit).withConfig({
    componentId: "sc-29f87150-2"
})(_templateObject3(), (0,_lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_2__/* .gte */ .eg)("lg")(_templateObject2()));
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-29f87150-3"
})(_templateObject4(), _lendi_ui_container__WEBPACK_IMPORTED_MODULE_4__/* .container */ .n);
var CardWrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-29f87150-4"
})(_templateObject5(), (0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_8__/* .display */ .jf)({
    mobile: "none",
    desktop: "block"
}));
// Default Sign in
var DefaultLoginWrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-29f87150-5"
})(_templateObject6());
// For AB testing we could have variants, this is the wrapper for that.
var LoginVariantWrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-29f87150-6"
})(_templateObject8(), (0,_lendi_ui_grid__WEBPACK_IMPORTED_MODULE_5__/* .unit */ .bf)({
    size: 1
}), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_6__.my)("md"), (0,_lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_2__/* .gte */ .eg)("tablet")(_templateObject7(), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_6__.my)("lg")));
// Left side variant
var LoginVariantContainer = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-29f87150-7"
})(_templateObject9(), (0,_lendi_ui_grid__WEBPACK_IMPORTED_MODULE_5__/* .unit */ .bf)({
    size: {
        mobile: 0.9,
        tablet: 3 / 8,
        desktop: 6 / 16
    },
    offset: {
        mobile: 0,
        tablet: 0,
        desktop: 2 / 16
    }
}));
// Right side variant
var ExtraContainer = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-29f87150-8"
})(_templateObject10(), (0,_lendi_ui_grid__WEBPACK_IMPORTED_MODULE_5__/* .unit */ .bf)({
    size: {
        tablet: 3.5 / 8,
        desktop: 7 / 16
    },
    offset: {
        tablet: 0,
        desktop: 1 / 16
    }
}), (0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_8__/* .display */ .jf)({
    mobile: "none",
    tablet: "inherit"
}));
var StyledRequestCode = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-29f87150-9"
})(_templateObject11(), (0,_lendi_ui_grid__WEBPACK_IMPORTED_MODULE_5__/* .unit */ .bf)({
    size: {
        mobile: 1
    }
}));
var Content = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-29f87150-10"
})(_templateObject12(), (0,_lendi_ui_grid__WEBPACK_IMPORTED_MODULE_5__/* .unit */ .bf)({
    size: {
        mobile: 1,
        tablet: 0.9,
        desktop: 0.6
    }
}));
var Heading = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-29f87150-11"
})(_templateObject13(), (0,_lendi_ui_grid__WEBPACK_IMPORTED_MODULE_5__/* .unit */ .bf)({
    size: {
        mobile: 1,
        tablet: 0.9,
        desktop: 0.7
    }
}), (0,_lendi_ui_typography__WEBPACK_IMPORTED_MODULE_7__/* .heading */ .nP)({
    size: "md",
    color: "shade.800"
}));
var SubHeading = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-29f87150-12"
})(_templateObject14(), (0,_lendi_ui_typography__WEBPACK_IMPORTED_MODULE_7__/* .body */ .d1)({
    size: "md",
    color: "shade.700"
}), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_6__.my)("lg"));
var Mainpage = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-29f87150-13"
})(_templateObject16(), _lendi_ui_container__WEBPACK_IMPORTED_MODULE_4__/* .container */ .n, (0,_lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_2__/* .gte */ .eg)("desktop")(_templateObject15()));
var ContentWrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-29f87150-14"
})(_templateObject18(), (0,_lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_2__/* .between */ .vX)("mobile", "tablet")(_templateObject17(), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_6__.mx)("xs")));
var BeforeWrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-29f87150-15"
})(_templateObject19(), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_6__.ml)("sm"), (0,_lendi_ui_typography__WEBPACK_IMPORTED_MODULE_7__/* .body */ .d1)({
    size: "lg",
    color: "shade.500"
}));
var AlertWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_lendi_ui_alert__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-29f87150-16"
})(_templateObject20(), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_6__.mb)("sm"));
var RFFFieldWrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-29f87150-17"
})(_templateObject21(), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_6__.mb)("sm"));
var WordWrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-29f87150-18"
})(_templateObject22());
var NoBr = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-29f87150-19"
})(_templateObject23());
var AuthForm = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].form.withConfig */ .ZP.form.withConfig({
    componentId: "sc-29f87150-20"
})(_templateObject25(), (0,_lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_2__/* .gte */ .eg)("tablet")(_templateObject24()));
var DivMBSM = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-29f87150-21"
})(_templateObject26(), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_6__.mb)("sm"));
var Separator = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].hr.withConfig */ .ZP.hr.withConfig({
    componentId: "sc-29f87150-22"
})(_templateObject27(), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_6__.my)("lg"), (0,_lendi_ui_color__WEBPACK_IMPORTED_MODULE_3__/* .color */ .$)("shade.200"));
var MainContentWrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-29f87150-23"
})(_templateObject28());
var Prompt = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-29f87150-24"
})(_templateObject30(), (0,_lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_2__/* .gte */ .eg)("tablet")(_templateObject29()), (0,_lendi_ui_depth__WEBPACK_IMPORTED_MODULE_11__/* .depth */ .Y)(1));
// @ts-ignore
var PromptHeader = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_lendi_ui_typography__WEBPACK_IMPORTED_MODULE_7__/* .Heading */ .X6).withConfig({
    componentId: "sc-29f87150-25"
})(_templateObject31());
var PromptMessage = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_lendi_ui_typography__WEBPACK_IMPORTED_MODULE_7__/* .Body */ .uT).withConfig({
    componentId: "sc-29f87150-26"
})(_templateObject32());
var Actions = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-29f87150-27"
})(_templateObject34(), (0,_lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_2__/* .gte */ .eg)("tablet")(_templateObject33()));
var YesNoButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_lendi_ui__WEBPACK_IMPORTED_MODULE_9__/* .Button */ .zx).withConfig({
    componentId: "sc-29f87150-28"
})(_templateObject36(), (0,_lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_2__/* .gte */ .eg)("tablet")(_templateObject35()));


/***/ }),

/***/ 78842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ postcode; },
  "getTexts": function() { return /* binding */ getTexts; }
});

// EXTERNAL MODULE: ../../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(44229);
// EXTERNAL MODULE: ../../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 5 modules
var _sliced_to_array = __webpack_require__(89799);
// EXTERNAL MODULE: ../../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(92712);
// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../node_modules/@lendi/ui/Button/dist/ui.esm.js
var ui_esm = __webpack_require__(39351);
// EXTERNAL MODULE: ../node_modules/@lendi/ui/Typography/dist/ui.esm.js
var dist_ui_esm = __webpack_require__(47994);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ./components/atoms/BoldHeading.tsx
var BoldHeading = __webpack_require__(44556);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/typography/dist/typography.esm.js
var typography_esm = __webpack_require__(56158);
// EXTERNAL MODULE: ../../../node_modules/@lendi/address-picker/dist/address-picker.esm.js + 77 modules
var address_picker_esm = __webpack_require__(94563);
// EXTERNAL MODULE: ../../../packages/lala-utils/dist/esm/index.js + 23 modules
var esm = __webpack_require__(82839);
// EXTERNAL MODULE: ../../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(78645);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/spacing/dist/spacing.esm.js
var spacing_esm = __webpack_require__(84209);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/icon/Info/dist/icon.esm.js
var icon_esm = __webpack_require__(51198);
// EXTERNAL MODULE: ../../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(96324);
;// CONCATENATED MODULE: ./components/PostcodePicker/style.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var Alert = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5ce779bc-0"
})(_templateObject(), (0,spacing_esm.pt)("sm"));
var InfoWrapper = (0,styled_components_browser_esm/* default */.ZP)(icon_esm/* default */.Z).withConfig({
    componentId: "sc-5ce779bc-1"
})(_templateObject1());

;// CONCATENATED MODULE: ./components/PostcodePicker/index.tsx






var PostcodePicker = function(param) {
    var onSelect = param.onSelect, onReset = param.onReset, onChange = param.onChange, canContinue = param.canContinue;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(address_picker_esm/* default */.Z, {
                size: "md",
                onSelectAddress: onSelect,
                placeholder: "Enter postcode or suburb…",
                onChange: onChange,
                onReset: onReset,
                source: "aussie",
                regionSearchOnly: true,
                onException: function(e) {
                    return esm/* LalaSentry.logToSentry */.GG.logToSentry("Address picker in Lala: ${e}");
                }
            }),
            !canContinue && /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(typography_esm/* Body */.uT, {
                    color: "warn.500",
                    size: "xs",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoWrapper, {
                            color: "warn.500"
                        }),
                        " Please enter a postcode or suburb"
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/grid/dist/grid.esm.js
var grid_esm = __webpack_require__(63518);
;// CONCATENATED MODULE: ./pages-styles/postcode.style.ts

function postcode_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  ",
        "\n"
    ]);
    postcode_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function postcode_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    postcode_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var ButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ad9da6a-0"
})(postcode_style_templateObject(), (0,spacing_esm.mt)("lg"));
var SecondSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ad9da6a-1"
})(postcode_style_templateObject1(), (0,spacing_esm.my)("md"));
var ThirdSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ad9da6a-2"
})(_templateObject2());
var SubGrid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ad9da6a-3"
})(_templateObject3(), (0,grid_esm/* unit */.bf)({
    size: {
        xs: 1,
        sm: 1,
        lg: 4
    }
}));
// @ts-ignore
var PageWrapper = (0,styled_components_browser_esm/* default */.ZP)(grid_esm/* Grid */.rj).withConfig({
    componentId: "sc-ad9da6a-4"
})(_templateObject4());

// EXTERNAL MODULE: ./helpers/tracking/index.ts + 53 modules
var tracking = __webpack_require__(67458);
;// CONCATENATED MODULE: ./pages/postcode/index.tsx











var Texts = {
    refinance: {
        header: "Where are you based?",
        subTitle: "This helps us give you the best refinancing experience."
    },
    newPurchase: {
        header: "Where are you based?",
        subTitle: "This helps us give you the best buying experience."
    },
    default: {
        header: "Where are you based?",
        subTitle: "This helps us give you a better digital experience."
    }
};
var getTexts = function() {
    var l3NewPurchase = sessionStorage.getItem("l3-NEW_HOME_LOAN");
    var l3Refinance = sessionStorage.getItem("l3-REFINANCE");
    if (!!l3NewPurchase && !!l3Refinance) {
        var isRefinanceLatest = JSON.parse(l3Refinance).timestamp > JSON.parse(l3NewPurchase).timestamp;
        return isRefinanceLatest ? Texts.refinance : Texts.newPurchase;
    }
    if (!!l3NewPurchase) {
        return Texts.newPurchase;
    } else if (!!l3Refinance) {
        return Texts.refinance;
    } else {
        return Texts.default;
    }
};
var PostcodePage = function(param) {
    var hidePostcode = param.hidePostcode;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(true), 2), canContinue = ref[0], setCanContinue = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), patchCustomerObject = ref1[0], setPatchCustomerObject = ref1[1];
    var text = getTexts();
    react.useEffect(function() {
        tracking/* pageTracking.trackAuthPage */.ep.trackAuthPage(tracking/* pageTracking.authTrackingPageName.POST_CODE */.ep.authTrackingPageName.POST_CODE);
    }, []);
    var onNext = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (!patchCustomerObject || patchCustomerObject && (!patchCustomerObject.postcode || !patchCustomerObject.suburb)) {
                    setCanContinue(false);
                    return [
                        2
                    ];
                }
                tracking/* eventTracking.trackAuthButtonClickEvent */.fn.trackAuthButtonClickEvent("SSO", "NEXT", "primary");
                hidePostcode(true);
                return [
                    2
                ];
            });
        });
        return function onNext() {
            return _ref.apply(this, arguments);
        };
    }();
    var onSelect = function(selectedValue) {
        tracking/* eventTracking.trackAuthButtonClickEvent */.fn.trackAuthButtonClickEvent(JSON.stringify(selectedValue), "Postcode or Suburb");
        setPatchCustomerObject({
            state: selectedValue.state,
            postcode: selectedValue.postcode,
            suburb: selectedValue.suburb
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BoldHeading/* BoldHeading */.V, {
                size: "lg",
                as: "h1",
                color: "shade.700",
                mt: "xl",
                mb: "sm",
                align: "center"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SubGrid, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_ui_esm/* Text */.x, {
                        tag: "h3",
                        variant: "title2",
                        align: "center",
                        children: text.header
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SecondSection, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_ui_esm/* Text */.x, {
                            tag: "p",
                            variant: "body1",
                            align: "center",
                            children: text.subTitle
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ThirdSection, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PostcodePicker, {
                            onSelect: onSelect,
                            onChange: function() {
                                return setCanContinue(true);
                            },
                            onReset: function() {},
                            canContinue: canContinue
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_esm/* Button */.z, {
                            size: "md",
                            onPress: onNext,
                            variant: "primary",
                            type: "submit",
                            width: "200px",
                            children: "Next"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var postcode = (PostcodePage);


/***/ }),

/***/ 3541:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ../../../node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ../../../node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ })

}]);